/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    RuleFormDataAgencyOrGroup,
    RuleFormDataAgencyOrGroupFromJSON,
    RuleFormDataAgencyOrGroupFromJSONTyped,
    RuleFormDataAgencyOrGroupToJSON,
    SearchTravelRange,
    SearchTravelRangeFromJSON,
    SearchTravelRangeFromJSONTyped,
    SearchTravelRangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMRuleFormData
 */
export interface SMRuleFormData {
    /**
     * 
     * @type {string}
     * @memberof SMRuleFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SMRuleFormData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SMRuleFormData
     */
    relevance?: number;
    /**
     * 
     * @type {number}
     * @memberof SMRuleFormData
     */
    maxPriceSolutions?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SMRuleFormData
     */
    maxPricePoints?: number | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof SMRuleFormData
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof SMRuleFormData
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<number>}
     * @memberof SMRuleFormData
     */
    brands?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SMRuleFormData
     */
    markets?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SMRuleFormData
     */
    distributionChannels?: Array<number> | null;
    /**
     * 
     * @type {Array<RuleFormDataAgencyOrGroup>}
     * @memberof SMRuleFormData
     */
    agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof SMRuleFormData
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SMRuleFormData
     */
    salesJourneys?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleFormData
     */
    cloneSourceId?: string | null;
    /**
     * 
     * @type {Array<SearchTravelRange>}
     * @memberof SMRuleFormData
     */
    travelDates?: Array<SearchTravelRange> | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SMRuleFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
}

export function SMRuleFormDataFromJSON(json: any): SMRuleFormData {
    return SMRuleFormDataFromJSONTyped(json, false);
}

export function SMRuleFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMRuleFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : json['maxPriceSolutions'],
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : json['maxPricePoints'],
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'brands': !exists(json, 'brands') ? undefined : json['brands'],
        'markets': !exists(json, 'markets') ? undefined : json['markets'],
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : json['distributionChannels'],
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : (json['agenciesAndGroups'] === null ? null : (json['agenciesAndGroups'] as Array<any>).map(RuleFormDataAgencyOrGroupFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : json['salesJourneys'],
        'cloneSourceId': !exists(json, 'cloneSourceId') ? undefined : json['cloneSourceId'],
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(SearchTravelRangeFromJSON)),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
    };
}

export function SMRuleFormDataToJSON(value?: SMRuleFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
        'description': value.description,
        'comment': value.comment,
        'relevance': value.relevance,
        'maxPriceSolutions': value.maxPriceSolutions,
        'maxPricePoints': value.maxPricePoints,
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'brands': value.brands,
        'markets': value.markets,
        'distributionChannels': value.distributionChannels,
        'agenciesAndGroups': value.agenciesAndGroups === undefined ? undefined : (value.agenciesAndGroups === null ? null : (value.agenciesAndGroups as Array<any>).map(RuleFormDataAgencyOrGroupToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'salesJourneys': value.salesJourneys,
        'cloneSourceId': value.cloneSourceId,
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(SearchTravelRangeToJSON)),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
    };
}


